/**
 * 聊天历史本地存储模块
 * 用于默认助手的聊天记录持久化
 * 使用 sessionStorage：关闭浏览器/窗口时自动清除
 */

var STORAGE_KEY = 'ai-chat-guest-history'

/**
 * 保存默认助手的聊天历史
 * @param {object} data { assistants, topics, messages, selectedAssistantId, selectedTopicId }
 */
export function saveGuestHistory(data) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  } catch (e) {
    console.error('保存聊天历史失败:', e)
  }
}

/**
 * 读取默认助手的聊天历史
 * @returns {object|null} 历史数据，无则返回 null
 */
export function getGuestHistory() {
  try {
    var raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    console.error('读取聊天历史失败:', e)
    return null
  }
}

/**
 * 清除默认助手的聊天历史
 */
export function clearGuestHistory() {
  sessionStorage.removeItem(STORAGE_KEY)
}
